// extracted by mini-css-extract-plugin
module.exports = {"FooterColumn":"styles_FooterColumn__rDfAA","items":"styles_items__Adcdv","link":"styles_link__yI_bc"};